// extracted by mini-css-extract-plugin
module.exports = {"footer":"DashboardFooterSection_footer__16X6b","link":"DashboardFooterSection_link__2HfZ5"};